import { render, staticRenderFns } from "./institutions.vue?vue&type=template&id=2b15d382&"
import script from "./institutions.vue?vue&type=script&lang=js&"
export * from "./institutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports